import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { CoursesPreview } from "@/components/landing/CoursesPreview";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";

export type LandingProps = {
  /** Kept for backwards compatibility with AppShell; unused on the new landing. */
  onBuy?: (planId: string) => void;
};

export function Landing({ onBuy: _onBuy }: LandingProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <Features />
        <CoursesPreview />
        <HowItWorks />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default Landing;
